module.exports = {"id":"231919","name":"Alessandro Murgia","rating":"72","photo":"./data/images/photos/4/231919.png","club":{"name":"Lazio Rome","logo":"./data/images/clubs/LazioRome.png"},"positions":["MC","MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/AlessandroMurgia0.json
// module id = 197
// module chunks = 0